import React, { useState } from "react";
import SorenHello from "@/components/landing/SorenHello";

// Our own mark: the bot head from the BotChainCP logo inside a chain ring.
// The render has an EMPTY visor on purpose — the face is drawn on top as SVG so it
// can blink and break into a smile. Upright at rest, leans toward the pointer.
// His typed greeting is anchored to this wrapper so it can sit beside him.
export const HeroEmblem = () => {
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  const lean = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    setTilt({ x: +(-py * 18).toFixed(2), y: +(px * 18).toFixed(2) });
  };

  return (
    <div className="hero-emblem-wrap">
      <div className="hero-stage" data-testid="hero-emblem" onMouseMove={lean} onMouseLeave={() => setTilt({ x: 0, y: 0 })}>
      <div className="hero-emblem-3d" style={{ transform: `rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)` }}>
        <img src="/hero/bot-ring-face.png" alt="BotChain CP emblem" className="hero-emblem-img" data-testid="hero-emblem-front" />
        {/* Face box sits exactly over the visor panel (measured off the render);
            eyes + smile are placed so their combined ink centres on the panel. */}
        <svg className="bot-face" viewBox="0 0 100 100" data-testid="hero-emblem-face" aria-hidden="true">
          <g className="bot-eye" style={{ transformOrigin: "30px 42.5px" }}>
            <ellipse cx="30" cy="42.5" rx="8.6" ry="9.8" fill="#2EE6F7" />
          </g>
          <g className="bot-eye bot-eye-r" style={{ transformOrigin: "70px 42.5px" }}>
            <ellipse cx="70" cy="42.5" rx="8.6" ry="9.8" fill="#2EE6F7" />
          </g>
          {/* Eyes end at 52.3; the mouth's top edge starts at 58.1, so there is a
              real gap at every column. It grows downward from its own top edge, so
              it never creeps into the eyes mid-animation. */}
          <path className="bot-smile" d="M33 60.2 Q50 72.2 67 60.2" fill="none" stroke="#2EE6F7" strokeWidth="4.2" strokeLinecap="round" />
        </svg>
      </div>
      </div>

      <SorenHello />
    </div>
  );
};

export default HeroEmblem;
